// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__EgaF5"};